import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormModule } from './form/form.module';
import { HttpClient, HttpClientModule, HttpHandler } from '@angular/common/http';
import { HttpModule } from '@angular/http';

@NgModule({
  imports: [
    CommonModule,
    FormModule,
    HttpClientModule
  ],
  exports: [FormModule],
  declarations: [],
  providers: [HttpClient]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/shared/shared.module.ts